import React, { FC } from 'react';
import Box from '@material-ui/core/Box';
import {
  makeStyles,
  createStyles,
  Button,
  Typography,
} from '@material-ui/core';
import BottomDrawerLayout, {
  DrawerSnapType,
} from '../../bottom-drawer-layout/BottomDrawerLayout';
import { useTranslation } from '../../../../../hooks/useTranslation';
import colors from '../../../../../themes/main-colors';
import ExclamationIcon from '../../../../../static/exclamationIcon.svg';

const useStyles = makeStyles(() =>
  createStyles({
    bottomSheet: {
      padding: '20px 20px 0',
      paddingTop: 0,
      textAlign: 'center',
      height: 'auto',
    },
    cancelButton: {
      color: colors.brightBlue,
      textAlign: 'center',
      marginTop: '1rem',
      textDecoration: 'underline',
    },
    dimOrFlickeringMessageHeader: {
      marginBottom: '1rem',
    },
    buttonBox: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
    },
    safetyPriorityCallButton: {
      fontSize: '1rem',
      borderRadius: 18,
      color: colors.white,
      width: '100%',
      background: colors.orange,
      letterSpacing: 0.32,
      '&:hover': {
        fontSize: '1rem',
        borderRadius: 18,
        color: colors.white,
        width: '100%',
        background: colors.orange,
        letterSpacing: 0.32,
      },
    },
  }),
);

type Props = {
  open: boolean;
  onClose: () => void;
};

const { t, richT } = useTranslation();
const customerCareNumber = t('CUSTOMER_CARE_NUMBER_OTHER');

const DimOrFlickeringMob: FC<Props> = ({ onClose }: Props) => {
  const classes = useStyles();
  const handleEvent = () => {
    setTimeout(function() {
      window.postMessage(t('CUSTOMER_CARE_NUMBER_OTHER'));
    }, 2000);
  };
  const handleClick = () => {
    onClose;
    handleEvent();
  };
  return (
    <BottomDrawerLayout
      onClose={onClose}
      data-testid={'notification-options'}
      refId={0}
      defaultSnap={DrawerSnapType.default}
    >
      <Box component="div" className={classes.bottomSheet}>
        <ExclamationIcon style={{ width: '100%', marginBottom: '1rem' }} />
        <Typography
          variant={'h3'}
          className={classes.dimOrFlickeringMessageHeader}
        >
          {t('YOUR_SAFETY_IS_OUR_TOP_PRIORITY')}
        </Typography>
        <Typography variant={'subtitle1'}>
          {richT('SAFETY_PRIORITY_MESSAGE')}
        </Typography>

        <Box className={classes.buttonBox}>
          <Button
            aria-label="checking-breaker-close"
            className={classes.safetyPriorityCallButton}
            onClick={() => handleClick()}
          >
            <Typography>
              {
                <a
                  href={'tel:' + customerCareNumber}
                  style={{
                    textDecoration: 'none',
                    color: colors.white,
                    fontSize: 'smaller',
                  }}
                >
                  {' '}
                  {t('CUSTOMER_CARE_NUMBER_OTHER')}
                </a>
              }
            </Typography>
          </Button>
          <Button
            className={classes.cancelButton}
            disableRipple={true}
            onClick={onClose}
          >
            <Typography variant={'h4'} noWrap>
              {t('CLOSE')}
            </Typography>
          </Button>
        </Box>
      </Box>
    </BottomDrawerLayout>
  );
};

export default DimOrFlickeringMob;
